import { jsx } from "react/jsx-runtime";
import { usePromptInputAttachments, PromptInputAttachments, PromptInputAttachment } from "../../../ai-elements/prompt-input.js";
import { useEffect } from "react";
const AttachmentsRow = ({ onAttachmentsChange, styles }) => {
  const attachments = usePromptInputAttachments();
  useEffect(() => {
    onAttachmentsChange(attachments.files.length > 0);
  }, [attachments.files.length, onAttachmentsChange]);
  if (attachments.files.length === 0) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    "div",
    {
      style: { paddingLeft: styles.paddingX, paddingRight: styles.paddingX, paddingTop: styles.paddingY },
      className: "tw:flex tw:flex-row tw:flex-wrap tw:gap-1",
      children: /* @__PURE__ */ jsx(PromptInputAttachments, { children: (attachment) => /* @__PURE__ */ jsx(PromptInputAttachment, { data: attachment }) })
    }
  );
};
export {
  AttachmentsRow
};
//# sourceMappingURL=AttachmentsRow.js.map
